import Vue from 'vue'

function actionMatches(ruleAction, requestedAction) {
  return ruleAction === 'manage' || ruleAction === requestedAction
}

function subjectMatches(ruleSubject, requestedSubject) {
  if (ruleSubject === 'all') return true
  return ruleSubject === requestedSubject
}

/**
 * Minimal ACL compatible with previous @casl/ability usage in this app:
 * rules are { action, subject } objects; can(action, subject); update(rules).
 * Vue.observable keeps templates in sync when rules change.
 */
export default class SimpleAbility {
  constructor(initialRules = []) {
    this._state = Vue.observable({
      rules: Array.isArray(initialRules) ? [...initialRules] : [],
    })
  }

  update(rules) {
    this._state.rules = Array.isArray(rules) ? [...rules] : []
  }

  can(requestedAction, requestedSubject) {
    const { rules } = this._state
    for (let i = 0; i < rules.length; i += 1) {
      const rule = rules[i]
      if (!rule || rule.inverted) continue
      const ra = rule.action
      const rs = rule.subject
      if (actionMatches(ra, requestedAction) && subjectMatches(rs, requestedSubject)) {
        return true
      }
    }
    return false
  }
}
